import React from 'react';
import EventNoteIcon from '@mui/icons-material/EventNote';
import { useTheme } from '@mui/material/styles';
import { Stack } from '../material';

const EmptyOrganizationEventImage: React.FC = () => {
  const { palette } = useTheme();
  return (
    <Stack
      bgcolor={palette.EmptyPlaceholderIcons.Background}
      width={56}
      height={56}
      borderRadius={'50%'}
      alignItems="center"
      justifyContent="center"
    >
      <EventNoteIcon sx={{ color: palette.EmptyPlaceholderIcons.IconFill, fontSize: 24 }} />
    </Stack>
  );
};

export default EmptyOrganizationEventImage;
